// extracted by mini-css-extract-plugin
export default {"sourcesList":"ChatMessage_sourcesList__+1qRu","markdown":"ChatMessage_markdown__oCrxH"};